import React from "react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from "@gettactic/components/src/primitives/Popover/Popover";
import { Label } from "@cmp-src/primitives/label";
import { InformationCircleIcon } from "@heroicons/react/outline";
import { ReserveFormUsers } from "@/features/reserve/components/Reserve/controls/ReserveFormUsers";
import { ReserveFormOrganizer } from "@/features/reserve/components/Reserve/controls/ReserveFormOrganizer";
import { useReserveForm } from "@/features/reserve/components/Reserve/ReserveFormProvider";

const classes = {
  Section: "flex flex-col gap-1.5",
  LabelRow: "flex items-center gap-1.5",
  InfoIcon: "h-4 w-4 cursor-pointer text-neutral-400"
};

interface AdminReservationLabelProps {
  htmlFor: string;
  text: string;
  hint: string;
  hintWidthClassName: string;
}

const AdminReservationLabel: React.FC<AdminReservationLabelProps> = ({
  htmlFor,
  text,
  hint,
  hintWidthClassName
}) => (
  <div className={classes.LabelRow}>
    <Label htmlFor={htmlFor} className="w-auto">
      {text}
    </Label>
    <Popover>
      <PopoverTrigger asChild>
        <InformationCircleIcon className={classes.InfoIcon} />
      </PopoverTrigger>
      <PopoverContent side="top" className={`z-20 ${hintWidthClassName}`}>
        <span>{hint}</span>
      </PopoverContent>
    </Popover>
  </div>
);

export const ReserveFormAdminReservation: React.FC = () => {
  const { enableAdminReservation, isMeetingRoom } = useReserveForm();
  if (!enableAdminReservation) return null;

  return (
    <div className={classes.Section}>
      {!isMeetingRoom ? (
        <>
          <AdminReservationLabel
            htmlFor="users"
            text="User"
            hint="As an admin or scheduler, you can make reservation on behalf of other users."
            hintWidthClassName="w-[250px]"
          />
          <ReserveFormUsers />
        </>
      ) : (
        <>
          <AdminReservationLabel
            htmlFor="organizer"
            text="Organizer"
            hint="Select an organizer for the meeting. As you are creating this reservation on behalf of another user, you will not be the organizer. Add yourself as a guest if you are attending."
            hintWidthClassName="w-[300px]"
          />
          <ReserveFormOrganizer />
        </>
      )}
    </div>
  );
};
